const DocumentData = ({
  width,
  height,
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width || '24'}
      height={height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 7.7999V2.3999H6.5998C5.60569 2.3999 4.7998 3.20579 4.7998 4.1999V19.7999C4.7998 20.794 5.60569 21.5999 6.5998 21.5999H17.3998C18.3939 21.5999 19.1998 20.794 19.1998 19.7999V9.5999H13.7998C12.8057 9.5999 11.9998 8.79401 11.9998 7.7999ZM11.9998 10.7999C12.3312 10.7999 12.5998 11.0685 12.5998 11.3999V18.5999C12.5998 18.9313 12.3312 19.1999 11.9998 19.1999C11.6684 19.1999 11.3998 18.9313 11.3998 18.5999V11.3999C11.3998 11.0685 11.6684 10.7999 11.9998 10.7999ZM8.9998 15.5999C9.33118 15.5999 9.5998 15.8685 9.5998 16.1999V18.5999C9.5998 18.9313 9.33117 19.1999 8.9998 19.1999C8.66843 19.1999 8.3998 18.9313 8.3998 18.5999V16.1999C8.3998 15.8685 8.66843 15.5999 8.9998 15.5999ZM14.9998 13.1999C15.3312 13.1999 15.5998 13.4685 15.5998 13.7999V18.5999C15.5998 18.9313 15.3312 19.1999 14.9998 19.1999C14.6684 19.1999 14.3998 18.9313 14.3998 18.5999V13.7999C14.3998 13.4685 14.6684 13.1999 14.9998 13.1999ZM13.1998 7.7999V2.6999L18.8998 8.3999H13.7998C13.4684 8.3999 13.1998 8.13127 13.1998 7.7999Z"
        fill="url(#paint0_linear_229_4024)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_229_4024"
          x1="-4.00097"
          y1="1.99952"
          x2="37.8532"
          y2="30.401"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#004D70" />
          <stop offset="1" stopColor="#298EE6" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default DocumentData;
